import {UserNotification} from "./Login.style";
import {Constants} from "@tpd-web-react-libs/nodejs-library/dist/src/common";
import React from "react";

export type TNotificheUtenteProps = {
    unreadNotifications: number
}

const URL = Constants.url[1];

export const NotificheUtente = (props: TNotificheUtenteProps) => {
    return (
        <>
            <UserNotification className="inline tpd_top_icon_second notification" data-testid="notifiche-utente">
                {props.unreadNotifications > 0 && (
                    <div
                        data-testid="notifiche-utente-more-than-99"
                        className={`position-right notifications-counter${props.unreadNotifications > 99 ? '-plus-99' : ''}`}>
                        {props.unreadNotifications > 99 ? "99+" : props.unreadNotifications}
                    </div>
                )}
                <a
                    className="tpd_notransform no-decoration"
                    href={URL?.notificheAreaRiservata}
                    title={props.unreadNotifications > 0 ? 'Le tue notifiche' : 'Nessuna notifica da leggere'}
                    data-testid="notifiche-utente-more-than-zero"
                >
                    <i className="icon-Notifiche"/>
                </a>
            </UserNotification>
        </>
    )
}

NotificheUtente.defaultProps = {}